/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, n2: NonNullable<unknown> }} Element_With_Uid_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Element with number {n} or {n2} was not found" |
*
* @param {Element_With_Uid_Not_FoundInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const element_with_uid_not_found = /** @type {((inputs: Element_With_Uid_Not_FoundInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Element_With_Uid_Not_FoundInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Element with number ${i?.n} or ${i?.n2} was not found`)
	return /** @type {LocalizedString} */ (`L'élément avec le numéros ${i?.n} ou ${i?.n2} n'a pas été trouvé`)
});